<template>
  <div>
    <div class="add-lang-title">
      <div class="common-flex" v-if="type !== 3">
        <span class="add-lang-span">添加多语言</span>
        <i
          class="el-icon-circle-plus-outline add-lang-icon"
          @click="addLang"
          title="添加多语言"
        ></i>
      </div>
    </div>
    <el-row>
      <div v-for="(lang, index) in langList" :key="index" class="top-flex">
        <div class="lang-label">
          <i
            class="el-icon-remove-outline del-lang-icon"
            @click="delLang(lang)"
            title="删除多语言"
            v-if="type !== 3"
          ></i>
          <el-select
            v-model="lang.languageKey"
            placeholder="请选择"
            size="mini"
            class="lang-select"
            :disabled="type === 3"
          >
            <el-option
              v-for="item in languages"
              :key="item.id"
              :label="item.languageName"
              :value="item.languageKey"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex1">
          <el-form :ref="'lang_' + index" :model="lang" label-width="80px" :rules="lang.rules">
            <el-form-item
              v-if="type !== 4 && type !== 5"
              label="产品名称"
              prop="multiLanguageProductName"
            >
              <el-input
                :disabled="type === 3"
                v-model="lang.multiLanguageProductName"
                placeholder="请填写境外产品名称，最多100字"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="type !== 4 && type !== 5"
              label="产品描述"
              prop="multiLanguageProductDescribe"
            >
              <el-input
                :disabled="type === 3"
                type="textarea"
                :rows="2"
                placeholder="请填写境外产品描述，用于对外展示，最多2000字"
                v-model="lang.multiLanguageProductDescribe"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              v-if="type === 4 || type === 5"
              label="更新内容"
              prop="multiLanguageupdateContent"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请填写境外版本更新说明，用于对外展示，最多2000字"
                v-model="lang.multiLanguageupdateContent"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['type'],
  data() {
    return {
      hasEmpty: false,
      langList: [], // 多语言列表
      languages: [],
      lang: {
        languageKey: '',
        multiLanguageProductName: '',
        multiLanguageProductDescribe: '',
        multiLanguageupdateContent: ''
      },
      rules: {
        multiLanguageProductName: [
          { message: '产品名称不得为空', trigger: 'blur', required: true },
          { max: 100, message: '最多100字', trigger: 'blur' }
        ],
        multiLanguageProductDescribe: [
          { message: '产品描述不得为空', trigger: 'blur', required: true },
          { max: 2000, message: '最多2000字', trigger: 'blur' }
        ],
        multiLanguageupdateContent: [
          { message: '更新内容不得为空', trigger: 'blur', required: true },
          { max: 2000, message: '最多2000字', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getMultiLanguage()
  },
  methods: {
    init(list) {
      this.hasEmpty = false
      // 新增
      if (list === '') {
        this.langList = []
      } else {
        this.langList = list
        this.langList.forEach((item, index) => {
          item.rules = this.rules
          this.$nextTick(() => {
            this.$refs['lang_' + index][0].clearValidate()
          })
        })
      }
    },

    // 获取多语言下拉列表
    getMultiLanguage() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getMultiLanguage'),
        method: 'get'
      })
        .then(res => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.languages = res.data
            if (this.languages.length > 0) {
              this.lang.languageKey = this.languages[0].languageKey
            }
          } else {
            this.languages = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {
          this.languages = []
        })
    },
    // 添加多语言
    addLang() {
      if (this.langList.length === 14) {
        this.$message.error('多语言不得超过14个')
        return
      }
      const t = new Date().getTime()
      const obj = {
        tid: t,
        languageKey: 'en',
        rules: this.rules
      }
      this.langList.push(obj)
    },
    // 删除单行的多语言
    delLang(lang) {
      if (lang.tid) {
        // 新加的
        this.langList = this.langList.filter(item => !item.tid || item.tid !== lang.tid)
      } else {
        // 后台详情接口给的
        this.langList = this.langList.filter(
          item => item.tid || item.languageKey !== lang.languageKey
        )
      }
    },
    submit() {
      this.hasEmpty = false
      if (this.langList.length === 0) {
        return
      }
      for (let i = 0; i < this.langList.length; i++) {
        this.$refs['lang_' + i][0].validate(valid => {
          if (!valid) {
            this.hasEmpty = true
          }
        })
        if (this.hasEmpty) {
          break
        }
      }
      return this.hasEmpty
    }
    // this.$refs['lang_'+item.languageKey][0].validate((valid) => {
    //       if (valid) {
    //         console.log('valid')
    //         // // 新增和编辑产品信息时
    //         // if (this.type === 1 || this.type === 2) {
    //         //   if (this.lang.multiLanguageProductName.trim() === '') {
    //         //     this.$message.error('产品名称不能为空')
    //         //     return
    //         //   }
    //         //   if (this.lang.multiLanguageProductDescribe.trim() === '') {
    //         //     this.$message.error('产品描述不能为空')
    //         //   }
    //         //   // 新增和编辑版本时
    //         // } else if (this.type === 4 || this.type === 5) {
    //         //   if (this.lang.multiLanguageupdateContent.trim() === '') {
    //         //     this.$message.error('产品更新内容不能为空')
    //         //   }
    //         // }
    //         // return true
    //       } else {
    //         console.log('unvalid')
    //         //   return false
    //       }
    //     })
  }
}
</script>

<style lang="scss" scoped>
.add-lang-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .add-lang-span {
    font-size: 16px;
    margin-right: 10px;
  }
  .add-lang-icon {
    font-size: 22px;
    cursor: pointer;
  }
}
.del-lang-icon {
  font-size: 22px;
  cursor: pointer;
  margin-right: 5px;
}
.lang-select {
  width: 150px;
  margin-right: 20px;
}
.lang-label {
  width: 200px;
  height: 28px;
  display: flex;
  align-items: center;
}
::v-deep {
  .el-form-item__label {
    line-height: unset;
  }
}
</style>
